/* ============================================================================
   VILLAINS TCG — Events (cst-events.js)
   Two tiny progressive enhancements: countdown timers (hero + featured event) and
   a "today" highlight on the weekly schedule. Works with JS off (the schedule just
   isn't highlighted; countdowns show their static 00s until scripted). Re-inits on
   shopify:section:load for the Theme Editor.
   ========================================================================== */
(() => {
  'use strict';
  const pad = (n) => String(n).padStart(2, '0');
  const set = (el, sel, val) => { const t = el.querySelector(sel); if (t) t.textContent = val; };

  /* ------------------------------------------------------------- countdown */
  const timers = new Set();
  let ticking = null;

  const paint = (el) => {
    const dl = Date.parse(el.dataset.deadline);
    // unparseable deadline (e.g. a merchant date typo) → hide the timer rather than
    // leave it frozen at --:--:--, which reads as broken
    if (isNaN(dl)) { el.hidden = true; timers.delete(el); return; }
    const units = el.querySelector('.cst-countdown__units');
    const done = el.querySelector('[data-cd-done]');
    let diff = dl - Date.now();
    if (diff <= 0) {
      if (units) units.hidden = true;
      if (done) done.hidden = false;
      timers.delete(el);
      return;
    }
    const d = Math.floor(diff / 864e5); diff -= d * 864e5;
    const h = Math.floor(diff / 36e5); diff -= h * 36e5;
    const m = Math.floor(diff / 6e4); diff -= m * 6e4;
    const s = Math.floor(diff / 1e3);
    set(el, '[data-cd-days]', pad(d));
    set(el, '[data-cd-hours]', pad(h));
    set(el, '[data-cd-mins]', pad(m));
    set(el, '[data-cd-secs]', pad(s));
  };

  const initCountdown = (el) => {
    if (!el || el.dataset.cstBound || !el.dataset.deadline) return;
    el.dataset.cstBound = '1';
    timers.add(el);
    paint(el);
    if (!ticking) {
      ticking = setInterval(() => {
        timers.forEach(paint);
        if (!timers.size) { clearInterval(ticking); ticking = null; }
      }, 1000);
    }
  };

  /* -------------------------------------------------------- today highlight */
  const DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const initWeek = (week) => {
    if (!week || week.dataset.cstBound) return;
    week.dataset.cstBound = '1';
    const today = DAYS[new Date().getDay()];
    week.querySelectorAll('.cst-week__day').forEach((d) => {
      if (d.dataset.day === today) d.classList.add('is-today');
    });
  };

  const scan = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-cst-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-cst-week]').forEach(initWeek);
    if (root && root.matches) {
      if (root.matches('[data-cst-countdown]')) initCountdown(root);
      if (root.matches('[data-cst-week]')) initWeek(root);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', (e) => scan(e.target || document));
})();
